import { put, select } from "redux-saga/effects";

import { unauthenticate } from "domains/authentication/actions";
import { getUserRole } from "domains/authentication/selectors";
import { activateModal } from "domains/modal/actions";

// We use the isFiringUnauthenticatedSingleton to throttle the calls to log
// the user out. This happens whenever we get a 401 response from an endpoint,
// so we could end up calling it multiple times in quick succession.
let isFiringUnauthenticatedSingleton = false;

export const getThrottledUnauthenticated = () => {
  if (isFiringUnauthenticatedSingleton) return true;
  isFiringUnauthenticatedSingleton = true;
  setTimeout(() => (isFiringUnauthenticatedSingleton = false), 2000);
  return false;
};

type UnknownAction = { meta?: { logoutOnAuthError?: boolean }; payload?: { error?: { status?: number } } };

export function* unauthenticatedErrorSaga({ meta, payload }: UnknownAction) {
  const userRole: ReturnType<typeof getUserRole> = yield select(getUserRole);
  if (!meta?.logoutOnAuthError || payload?.error?.status !== 401 || getThrottledUnauthenticated()) return;
  if (userRole === "Unauthenticated")
    yield put(
      activateModal({ id: "Authentication", params: { hasDelay: true, isAlwaysWhite: true, onDismissRoute: "/" } }),
    );
  else {
    yield put(unauthenticate());
    yield put(activateModal({ id: "Unauthenticated" }));
  }
}
